import request from '@/utils/request'

const getOfflineCode = data => request.post('/api/pin/getPin', data)

export default {
  getOfflineCode
}
